import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import { UserContext } from '../App';

export default function AuditLog() {
  const { currentUser, users } = useContext(UserContext);
  const [log, setLog] = useState([]);

  // Asset owner is the current logged-in user
  const assetHolder = currentUser;
  if (!assetHolder) {
    return <div>Loading...</div>;
  }

  useEffect(() => {
    api.get('/audit').then(res => {
      if (currentUser.type === 'nominee') {
        // Show only logs relevant to the nominee (e.g., actions involving their email or userId)
        setLog(res.data.filter(e => e.userId === assetHolder.id));
      } else {
        setLog(res.data.filter(e => e.userId === assetHolder.id));
      }
    });
  }, [currentUser, assetHolder.id]);

  return (
    <div style={{ padding: 20 }}>
      <h1>Audit Log</h1>
      <ul>{log.map(e => <li key={e.id}>{e.timestamp}: {e.action}</li>)}</ul>
    </div>
  );
}